import { render, staticRenderFns } from "./coderInpatientReviewPage.vue?vue&type=template&id=01a85b5e&scoped=true&"
import script from "./coderInpatientReviewPage.vue?vue&type=script&lang=js&"
export * from "./coderInpatientReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientReviewPage.vue?vue&type=style&index=0&id=01a85b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a85b5e",
  null
  
)

export default component.exports